 import app from 'firebase/app';
 import 'firebase/auth';
 import "firebase/firestore";
 import 'firebase/storage'; ///  storage

 import firebaseConfig from "./config";
 

  class Firebase {
      constructor() {
        app.initializeApp(firebaseConfig);
        this.auth = app.auth();
        this.db = app.firestore();
        this.storage = app.storage();
      }
      async register(name, email, password) {
        const newUser = await this.auth.createUserWithEmailAndPassword(
              email,
              password
        ) 
        await this.db.collection('colUsuarios').doc(newUser.user.uid).set({
          email: newUser.user.email,
          id: newUser.user.uid,
          nombre: name,
          apellido: "",
          telefono:"",
          fotoUrl: "",
          rol: 0,
        }) 
        return await newUser.user.updateProfile({
             displayName: name 
        })        
      }

      async login(email, password) {
        return await  this.auth.signInWithEmailAndPassword(email, password)
      }

      async logout() {
        await this.auth.signOut();
      }

      async resetPassword(email) {
        await this.auth.sendPasswordResetEmail(email);
      }

      guardarDocumento = (nombreDocumento, documento) => this.storage.ref().child(nombreDocumento).put(documento);

      devolverDocumento = (documentoUrl) => this.storage.ref().child(documentoUrl).getDownloadURL();
  }

  const firebase = new Firebase()
  export default firebase;